var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_34139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 15.5C4.25 16.9774 4.54099 18.4403 5.10636 19.8052C5.67172 21.1701 6.50039 22.4103 7.54505 23.455C8.58971 24.4996 9.8299 25.3283 11.1948 25.8936C12.5597 26.459 14.0226 26.75 15.5 26.75C16.9774 26.75 18.4403 26.459 19.8052 25.8936C21.1701 25.3283 22.4103 24.4996 23.455 23.455C24.4996 22.4103 25.3283 21.1701 25.8936 19.8052C26.459 18.4403 26.75 16.9774 26.75 15.5C26.75 12.5163 25.5647 9.65483 23.455 7.54505C21.3452 5.43526 18.4837 4.25 15.5 4.25C12.5163 4.25 9.65483 5.43526 7.54505 7.54505C5.43526 9.65483 4.25 12.5163 4.25 15.5Z",
    stroke: "#0069AA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 15.5H19.25",
    stroke: "#0069AA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.75V19.25",
    stroke: "#0069AA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_34139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.61f5f55daac2cc1cb089407c630c4549.svg";
export { ForwardRef as ReactComponent };